interface GenerateSearchParams {
  [name: string]: any;
}

export const generateSearchParams = (params: GenerateSearchParams = {}) =>
  Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
